export enum SupportedWallets {
  ethereum = 'ethereum',
  binance = 'binance',
  walletconnect = 'walletconnect',
  magiclink = 'magiclink',
}
export const signMessageToken = 'Welcome! Admin'

export const storageToken = 'accessToken'

export const webSiteMetamask = 'https://metamask.io/'
export const webSiteBinance =
  'https://chrome.google.com/webstore/detail/binance-wallet/fhbohimaelbohpjbbldcngcnapndodjp'
